import { Heading, Tab, Tabs } from '@alefeducation/ui-elements-library-core';
import React, { useMemo } from 'react';
import { OrganisationMembers, Settings } from './index';
import { OrgMembersViewTabs } from './types';
import {
  StyledContainer,
  StyledTabContainer,
  StyledTableBody,
  StyledTableHeader,
} from './styles';
import AddMemberButton from '../../components/OrganisationMembers/AddMemberButton';
import { RNPToastComponent } from '../../components/RolesAndPermissions/RNPToaster';
import { PaginationContext } from '../../components/Pagination/PaginationContext';
import { ORGANISATIONS } from '../../utils/constants';
import useOrgMembersTab from '../hooks/useOrgMembersTab';
import { SearchBox } from '../../components/RolesAndPermissions';
import isInCCLiframe from '../../utils/isInCCLiframe';

interface Props {
  currentTab: OrgMembersViewTabs;
}

const OrganisationMembersTabView = ({
  currentTab = OrgMembersViewTabs.Members,
}: Props) => {
  const {
    searchText,
    setSearchText,
    selectedTab,
    isViewOnlyRole,
    handleTabSelection,
  } = useOrgMembersTab({ currentTab });
  const paginationProviderData = useMemo(() => ({ searchText }), [searchText]);

  return (
    <div>
      <StyledContainer>
        {currentTab === OrgMembersViewTabs.Members && (
          <SearchBox onChange={setSearchText} />
        )}
      </StyledContainer>
      <StyledTabContainer>
        <StyledTableHeader className="table-header">
          <Heading variant="heading-medium">{ORGANISATIONS}</Heading>
          {currentTab === OrgMembersViewTabs.Members && !isViewOnlyRole && (
            <AddMemberButton />
          )}
        </StyledTableHeader>

        <StyledTableBody data-testid="table-body">
          <PaginationContext.Provider value={paginationProviderData}>
            <Tabs type="underline">
              <Tab
                label={OrgMembersViewTabs.Members}
                type="underline"
                active={selectedTab === OrgMembersViewTabs.Members}
                onClick={handleTabSelection}
              >
                <OrganisationMembers />
              </Tab>

              {isInCCLiframe ? (
                <React.Fragment />
              ) : (
                <Tab
                  label={OrgMembersViewTabs.Settings}
                  type="underline"
                  active={selectedTab === OrgMembersViewTabs.Settings}
                  onClick={handleTabSelection}
                >
                  <Settings />
                </Tab>
              )}
            </Tabs>
          </PaginationContext.Provider>
        </StyledTableBody>
      </StyledTabContainer>
      <RNPToastComponent />
    </div>
  );
};

export default OrganisationMembersTabView;
